import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import './LoginForm.css';

// Served from frontend/public — reference by URL, not a src import.
const communityLogo = `${process.env.PUBLIC_URL}/logo512.png`;

const SetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const email = searchParams.get('email') || '';

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (password.length < 8) {
            setError('Password must be at least 8 characters.');
            return;
        }
        if (password !== confirm) {
            setError('Passwords do not match.');
            return;
        }

        setLoading(true);
        try {
            await axios.post(`${API_BASE_URL}/api/set-password`, {
                email,
                token,
                password,
                password_confirmation: confirm,
            });
            setSuccess('Password set successfully. Redirecting to login...');
            setTimeout(() => navigate('/'), 1800);
        } catch (err) {
            if (err.response && err.response.data && err.response.data.message) {
                setError(err.response.data.message);
            } else if (err.response && err.response.data && err.response.data.errors) {
                const first = Object.values(err.response.data.errors)[0];
                setError(Array.isArray(first) ? first[0] : String(first));
            } else {
                setError('Something went wrong. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-form-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <img
                    src={communityLogo}
                    alt="InspireEHR Community Board"
                    className="login-logo"
                />
                <h1>Set Your Password</h1>
                {!token || !email ? (
                    <p className="error">
                        This set-password link is incomplete or invalid. Please use the
                        link that was sent to you.
                    </p>
                ) : (
                    <>
                        {error && <p className="error">{error}</p>}
                        {success && <p className="success">{success}</p>}
                        <div className="form-group">
                            <label>Email</label>
                            <input type="email" value={email} readOnly disabled />
                        </div>
                        <div className="form-group">
                            <label>New Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                minLength={8}
                                disabled={loading || !!success}
                            />
                        </div>
                        <div className="form-group">
                            <label>Confirm Password</label>
                            <input
                                type="password"
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                required
                                minLength={8}
                                disabled={loading || !!success}
                            />
                        </div>
                        <button
                            className="btn primary"
                            type="submit"
                            disabled={loading || !!success}
                        >
                            {loading ? 'Saving...' : 'Set Password'}
                        </button>
                    </>
                )}
                <p className="register-link">
                    <Link to="/">Back to login</Link>
                </p>
            </form>
        </div>
    );
};

export default SetPassword;
